import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Wine, Loader } from "lucide-react";

const S = {
  page:{minHeight:"100vh",background:"#F2F5EC",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Inter',sans-serif",padding:"20px 0"},
  box:{background:"#EDF1E4",border:"1px solid #252525",borderRadius:14,padding:"36px 32px",width:"100%",maxWidth:380},
  label:{fontSize:10,fontWeight:600,color:"#7A8E68",textTransform:"uppercase",letterSpacing:"0.1em",display:"block",marginBottom:6},
  input:{width:"100%",background:"#E8EDE0",border:"1px solid #222",borderRadius:8,padding:"11px 14px",fontSize:13,color:"#2C3820",fontFamily:"'Inter',sans-serif",outline:"none",boxSizing:"border-box",marginBottom:12},
  btn:{width:"100%",padding:"12px",background:"#6B2737",border:"none",borderRadius:8,color:"#DCE4EC",fontSize:14,fontWeight:500,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8},
};

export default function TravelerSignupPage() {
  const [form,setForm]=useState({full_name:"",email:"",password:""});
  const [consent,setConsent]=useState(false);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState("");
  const { register } = useAuth("traveler");
  const navigate = useNavigate();
  const setField=(k,v)=>setForm(f=>({...f,[k]:v}));

  const submit = async e => {
    e.preventDefault(); setError("");
    if (!consent) { setError("Please accept the Privacy Policy and Terms to continue."); return; }
    setLoading(true);
    try {
      await register({ ...form, role: "traveler", consent: true });
      navigate("/plan");
    }
    catch(err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={S.page}>
      <div style={S.box}>
        <div style={{textAlign:"center",marginBottom:24}}>
          <Wine size={28} color="#6B2737" style={{marginBottom:10}}/>
          <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:"#1E2C14",margin:"0 0 4px"}}>Create your account</h1>
          <p style={{fontSize:12,color:"#6A7E58",margin:0}}>Free — save tours, book tastings, get notified</p>
        </div>

        {error && <div style={{background:"rgba(107,39,55,0.1)",border:"1px solid rgba(107,39,55,0.2)",borderRadius:7,padding:"8px 12px",marginBottom:14,fontSize:12,color:"#886070"}}>{error}</div>}

        <form onSubmit={submit}>
          <label style={S.label}>Full name</label>
          <input style={S.input} value={form.full_name} onChange={e=>setField("full_name",e.target.value)} placeholder="Maria Müller"/>
          <label style={S.label}>Email</label>
          <input style={S.input} type="email" value={form.email} onChange={e=>setField("email",e.target.value)} placeholder="you@example.com" required/>
          <label style={S.label}>Password</label>
          <input style={S.input} type="password" value={form.password} onChange={e=>setField("password",e.target.value)} placeholder="Min. 8 characters" minLength={8} required/>

          <label style={{display:"flex",alignItems:"flex-start",gap:8,fontSize:11,color:"#6A7E58",marginBottom:16,cursor:"pointer"}}>
            <input type="checkbox" checked={consent} onChange={e=>setConsent(e.target.checked)} style={{marginTop:2}}/>
            <span>
              I agree to the <Link to="/terms" target="_blank" style={{color:"#886070"}}>Terms of Service</Link> and{" "}
              <Link to="/privacy" target="_blank" style={{color:"#886070"}}>Privacy Policy</Link>.
            </span>
          </label>

          <button type="submit" style={S.btn} disabled={loading}>
            {loading ? <Loader size={14}/> : null} Create account
          </button>
        </form>

        <p style={{textAlign:"center",fontSize:12,color:"#6A7E58",marginTop:20}}>
          Already have an account? <Link to="/tourist/login" style={{color:"#886070",textDecoration:"none"}}>Sign in</Link>
        </p>
        <p style={{textAlign:"center",fontSize:11,color:"#8A9E78",marginTop:8}}>
          <Link to="/plan" style={{color:"#8A9E78",textDecoration:"none"}}>Continue as guest instead</Link>
        </p>
      </div>
    </div>
  );
}
